import styled from 'styled-components';

export const OverflowText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
  & > input {
    position: relative;
  }
`;
